var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6C16 2.68629 18.6863 0 22 0H106C109.314 0 112 2.68629 112 6V122C112 125.314 109.314 128 106 128H22C18.6863 128 16 125.314 16 122V6Z",
    fill: "#FCFCFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M92 46V42C92 40.8954 91.1046 40 90 40H38C36.8954 40 36 40.8954 36 42V46C36 47.1046 36.8954 48 38 48H90C91.1046 48 92 47.1046 92 46Z",
    fill: "#878D96"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M92 64V60C92 58.8954 91.1046 58 90 58H38C36.8954 58 36 58.8954 36 60V64C36 65.1046 36.8954 66 38 66H90C91.1046 66 92 65.1046 92 64Z",
    fill: "#878D96"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76 82V78C76 76.8954 75.1046 76 74 76H38C36.8954 76 36 76.8954 36 78V82C36 83.1046 36.8954 84 38 84H74C75.1046 84 76 83.1046 76 82Z",
    fill: "#878D96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0.8H106C108.872 0.8 111.2 3.12812 111.2 6V122C111.2 124.872 108.872 127.2 106 127.2H22C19.1281 127.2 16.8 124.872 16.8 122V6C16.8 3.12812 19.1281 0.8 22 0.8Z",
    stroke: "#DDE1E6",
    strokeWidth: 1.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 128H106C109.314 128 112 125.314 112 122V118C112 121.314 109.314 124 106 124H22C18.6863 124 16 121.314 16 118V122C16 125.314 18.6863 128 22 128Z",
    fill: "#DDE1E6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.d6eadccca21ace8d2717a7a85a2a5f33.svg";
export { ForwardRef as ReactComponent };